<mat-icon class="mobile-menu" [matMenuTriggerFor]="menu">menu</mat-icon>
<mat-menu #menu="matMenu" xPosition="after" class="bg-primary">
  @for (item of navService.navItems; track item) {
    @let isNavVisible = navService.isSportVisible(item.name.toLowerCase(), "header") | async;
    @if (isNavVisible) {
      @if (item.name === "Casino") {
        <a (click)="navService.openCasino()" mat-menu-item>
          <span class="text-secondary">
            {{ item.name | translate }}
          </span>
        </a>
      } @else {
        <a [routerLink]="item.path" mat-menu-item>
          <span class="text-secondary">
            {{ item.name | translate }}
          </span>
        </a>
      }
    }
  }
</mat-menu>
